
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { stripMarkdown } from "../../helpers";
import { Utils } from "../../../../../utils";
import { ITeamNews } from "../../../../../services";
import styles from "../../assets/style.module.css";

export interface NewsCardProps {
    news: ITeamNews;
    to?: ReactRouterDom.To;
    onClick?: () => void;
}

function NewsCard({ news: n, to, onClick }: NewsCardProps) {

    const content = (<>
        <div className={styles["news-card-media"]}>
            {n.extra_data?.featured_image ? (<img src={n.extra_data.featured_image} alt={n.title} loading="lazy" />) : (<div className={styles["news-card-ph"]} />)}
            {n.extra_data?.category && (<span className={styles["card-badge"]}>{n.extra_data.category}</span>)}
        </div>
        <div className={styles["news-card-body"]}>
            <span className={styles["news-card-date"]}>{Utils.fineDate(new Date(n.updated_at))}</span>
            <h3 className={styles["h4"]}>{n.title}</h3>
            <p className={styles["news-card-excerpt"]}>{stripMarkdown(n.content, 120)}</p>
        </div>
    </>);

    if (to) {
        return (<ReactRouterDom.NavLink to={to} className={styles["news-card"]}>{content}</ReactRouterDom.NavLink>);
    }
    return (<div className={styles["news-card"]} onClick={onClick}>{content}</div>);
}

export default NewsCard;
